// src/admin/OrderDetailsModal.js
// مكون نافذة تفاصيل الطلب
import React from 'react';
import { formatDate } from '../utils/dateUtils';

const OrderDetailsModal = ({ order, onClose }) => {
  if (!order) return null;

  const getStatusClass = (status) => {
    if (status?.includes("تم التسليم")) return "status-delivered";
    if (status?.includes("تم الاستلام")) return "status-pickup";
    if (status?.includes("ملغي")) return "status-cancelled";
    return "status-pending";
  };

  // تنسيق التاريخ والوقت
  const formatOrderDate = (timestamp) => {
    if (!timestamp) return "غير متوفر";
    if (timestamp.toDate) {
      return formatDate(timestamp.toDate());
    }
    return "غير متوفر";
  };

  return (
    <div className="modal-overlay">
      <div className="order-details-modal">
        <div className="modal-header">
          <h2>تفاصيل الطلب</h2>
          <button className="close-button" onClick={onClose}>&times;</button>
        </div>
        
        <div className="modal-body">
          <div className="order-header-info">
            <div>
              <h3>رقم الطلب</h3>
              <p>{order.orderCode || order.id}</p>
            </div>
            <div className={`order-status ${getStatusClass(order.status)}`}>
              {order.status}
            </div>
          </div>
          
          <div className="info-section">
            <h3>معلومات العميل</h3>
            <div className="info-grid">
              <div className="info-item">
                <span className="info-label">الاسم:</span>
                <span className="info-value">{order.customerName || "غير متوفر"}</span>
              </div>
              <div className="info-item">
                <span className="info-label">رقم الهاتف:</span>
                <span className="info-value">{order.phone || "غير متوفر"}</span>
              </div>
              <div className="info-item">
                <span className="info-label">العنوان:</span>
                <span className="info-value">{order.address || "غير متوفر"}</span>
              </div>
              {order.notes && (
                <div className="info-item">
                  <span className="info-label">ملاحظات:</span>
                  <span className="info-value">{order.notes}</span>
                </div>
              )}
            </div>
          </div>
          
          <div className="info-section">
            <h3>معلومات المطعم</h3>
            <div className="info-grid">
              <div className="info-item">
                <span className="info-label">اسم المطعم:</span>
                <span className="info-value">{order.restaurantName || "غير متوفر"}</span>
              </div>
              <div className="info-item">
                <span className="info-label">عنوان المطعم:</span>
                <span className="info-value">{order.restaurantAddress || "غير متوفر"}</span>
              </div>
            </div>
          </div>
          
          <div className="info-section">
            <h3>معلومات التوصيل</h3>
            <div className="info-grid">
              <div className="info-item">
                <span className="info-label">السائق:</span>
                <span className="info-value">{order.driverName || "غير متوفر"}</span>
              </div>
              <div className="info-item">
                <span className="info-label">المسافة:</span>
                <span className="info-value">{order.distance ? `${order.distance.toFixed(2)} كم` : "غير متوفر"}</span>
              </div>
              <div className="info-item">
                <span className="info-label">وقت إنشاء الطلب:</span>
                <span className="info-value">{formatOrderDate(order.createdAt)}</span>
              </div>
            </div>
          </div>
          
          <div className="info-section">
            <h3>المعلومات المالية</h3>
            <div className="info-grid">
              <div className="info-item">
                <span className="info-label">قيمة الطلب:</span>
                <span className="info-value">{order.amount ? `${order.amount.toFixed(3)} د.ك` : "0.000 د.ك"}</span>
              </div>
              <div className="info-item">
                <span className="info-label">رسوم التوصيل:</span>
                <span className="info-value">{order.deliveryFee ? `${order.deliveryFee.toFixed(3)} د.ك` : "0.000 د.ك"}</span>
              </div>
              <div className="info-item">
                <span className="info-label">المبلغ الإجمالي:</span>
                <span className="info-value font-bold">{order.totalAmount ? `${order.totalAmount.toFixed(3)} د.ك` : "0.000 د.ك"}</span>
              </div>
              <div className="info-item">
                <span className="info-label">طريقة الدفع:</span>
                <span className="info-value">{order.paymentMethod || "غير متوفر"}</span>
              </div>
            </div>
          </div>
        </div>
        
        <div className="modal-footer">
          <button className="button primary" onClick={onClose}>إغلاق</button>
        </div>
      </div>
    </div>
  );
};

export default OrderDetailsModal;